"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRecipeAllCookbooks = void 0;
const recipesByCookbookAndSectionId_1 = require("../../queries/recipesByCookbookAndSectionId");
exports.createRecipeAllCookbooks = (store, recipe, _cookbookId, sectionId) => {
    if (!recipe) {
        return;
    }
    let data;
    try {
        data = store.readQuery({
            query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
            variables: { sectionId },
        });
    }
    catch (err) {
        return;
    }
    if (data) {
        store.writeQuery({
            query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
            variables: { sectionId },
            data: {
                __typename: "Query",
                recipesByCookbookAndSectionId: [
                    ...data.recipesByCookbookAndSectionId,
                    recipe,
                ],
            },
        });
    }
};
//# sourceMappingURL=createRecipeAllCookbooks.js.map